import type { ClockUser, StatusPunch } from '@src/api/punchTypes';
import { elapsedSince } from '@src/components/PunchPad/timeUtils';
import { useTranslation } from '@src/i18n';
import { UserChip } from './UserChip';
import './ClockedInView.css';
import { TimerIcon } from '@src/components/UserStatusPage/icons/TimerIcon';
import { Text } from '@7shifts/sous-chef-base';

interface ClockedInViewProps {
    user: ClockUser;
    punch: StatusPunch;
    serverTime: string;
}

export function ClockedInView({ user, punch, serverTime }: ClockedInViewProps) {
    const elapsed = elapsedSince(punch.clockedInAt, serverTime);
    const { t } = useTranslation();

    return (
        <div className="clocked-in-view" data-testid="clocked-in-view">
            <UserChip
                user={user}
                statusLabel={t('userStatus.punchedIn')}
                theme="success"
            />
            <div className="clocked-in-view__content">
                <TimerIcon className="clocked-in-view__timer-icon" />
                <div className="clocked-in-view__text-stack">
                    <Text as={'insight'}>{elapsed}</Text>
                    <Text as={'h4'}>{t('userStatus.timeOnShift')}</Text>
                </div>
            </div>
        </div>
    );
}
